export const isAccountTypeRegistered = (type: AccountType | undefined) => {
  switch (type) {
    case undefined:
    case AccountType.CASH: {
      return false;
    }

    default: {
      return true;
    }
  }
};

export enum AccountType {
  CASH = 'CASH',
  FHSA = 'FHSA',
  LIRA = 'LIRA',
  RESP = 'RESP',
  RRIF = 'RRIF',
  RRSP = 'RRSP',
  TFSA = 'TFSA',
}
